import moment from 'moment';
import React from 'react';
import TaskStatus from './TaskStatus';

export default (props) => {
  const printPager = () => {
    if (!props.queue.length) {
      return;
    }

    if (!props.queueTotal || props.queueTotal <= props.queueLimit) {
      return;
    }

    const pages = Math.ceil(props.queueTotal / props.queueLimit);
    const offsets = [];

    for (let i = 0; i < pages; i++) {
      offsets.push(i * props.queueLimit);
    }

    const lastOffset = offsets[offsets.length - 1];

    if (props.queueTotal && props.queueTotal > props.queueLimit) {
      return <ul className="pagination">
        <li className={(props.queueOffset === 0 || props.loading) ? 'disabled' : ''}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              props.handleSetOffset(0);
            }}
            aria-label="Previous"
            disabled={props.loading}
          >
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        {offsets.map((offset, i) => {
          return <li key={`page-${i}`} className={props.queueOffset === offset ? 'active' : (props.loading ? ' disabled' : '')}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                props.handleSetOffset(offset);
              }}
              disabled={props.loading}
            >
              {i + 1}
            </a>
          </li>;
        })}

        <li className={((props.queueOffset + props.queueLimit) > props.queueTotal || props.loading) ? 'disabled' : ''}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              props.handleSetOffset(lastOffset);
            }}
            aria-label="Next"
            disabled={props.loading}>
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>;
    }
  };

  const handleTaskDealerChange = (e) => {
    if (self[`taskParam2${e.target.name}`]) {
      self[`taskParam2${e.target.name}`].disabled = false;
      // Enable available makes for this dealer.
      const makesCSV = e.target.options[e.target.selectedIndex].dataset.makes;
      const options = self[`taskParam2${e.target.name}`].options;
      for (let i = 0; i < options.length; i++) {
        options[i].disabled = !makesCSV.includes(options[i].value);
      }
    }
  };

  const ungroupedTasks = [];
  const groupedTasks = {};

  for (const [taskId, taskProps] of Object.entries(props.tasks)) {
    if (taskProps.group) {
      groupedTasks[taskProps.group] = groupedTasks[taskProps.group] || [];
      groupedTasks[taskProps.group].push(taskId);
    } else {
      ungroupedTasks.push(taskId);
    }
  }

  return (
    <section>
      <h2>Konfigurerte handlinger</h2>
      <div className="table-responsive">
        <table className="table table-hover table-nowrap">
          <thead>
            <tr>
              <th>
                Oppgave
              </th>
              <th>
                Parameter
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {ungroupedTasks.map((taskId) => {
              const task = props.tasks[taskId];

              return <tr key={taskId}>
                <td title={taskId}>{task.name || taskId}</td>
                <td className="td-fullwidth form-inline">
                  {/*{task.cmd}*/}
                  {/* Assume first parameter is dealer slugs for now */}
                  {props.dealerSlugs && task.cmd.includes('#param') &&
                    <select className="form-control input-sm" defaultValue="" name={taskId} onChange={handleTaskDealerChange} ref={(ref) => (self[`taskParam${taskId}`] = ref)}>
                      <option value="">Alle</option>
                      {props.dealerSlugs.map((ds) => <option
                        key={ds.fields.slug['nb-NO']}
                        value={ds.fields.slug['nb-NO']}
                        data-makes={ds.fields.makes['nb-NO'].map((m) => m.fields.slug['nb-NO']).join(',')}
                      >{ds.fields.name['nb-NO']}</option>)}
                    </select>
                  }
                  &nbsp;
                  {/* Assume second parameter is makes for now */}
                  {(task.cmd.split('#param').length - 1) > 1 &&
                    <select className="form-control input-sm" defaultValue="" ref={(ref) => (self[`taskParam2${taskId}`] = ref)}>
                      <option value="">Alle merker</option>
                      <option value="hongqi">Hongqi</option>
                      <option value="mitsubishi">Mitsubishi</option>
                      <option value="renault">Renault</option>
                      <option value="dacia">Dacia</option>
                      <option value="voyah">Voyah</option>
                      <option value="dongfeng">Dongfeng</option>
                      <option value="changan">Changan</option>
                    </select>
                  }
                </td>
                <td>
                  <button className="btn btn-success" onClick={() => {
                    const param = self[`taskParam${taskId}`];
                    const param2 = self[`taskParam2${taskId}`];

                    let params;
                    if (param) {
                      params = [param.value];
                    }
                    if (param2) {
                      params.push(param2.value);
                    }

                    props.onRunTask(taskId, params);
                  }}>Kjør</button>
                </td>
              </tr>;
            })}
          </tbody>
        </table>
        {Object.keys(groupedTasks).length > 0 &&
          <div className="text-right">
            <span>Vis flere handlinger: </span>
            {Object.keys(groupedTasks).map((groupName, i) => (
              <React.Fragment key={i}><button className="btn btn-link" type="button" data-toggle="collapse" data-target={`#collapse-${i}`} aria-expanded="false" aria-controls="collapseExample">{groupName}</button>&nbsp;</React.Fragment>
            ))}
          </div>
        }
        {Object.keys(groupedTasks).map((groupName, i) => (
          <div key={groupName} className="collapse" id={`collapse-${i}`}>
            <table className="table table-hover table-nowrap">
              <tbody>
                {groupedTasks[groupName].map((taskId) => {
                  const task = props.tasks[taskId];

                  return <tr key={taskId}>
                    <td title={taskId}>{task.name || taskId}</td>
                    <td className="td-fullwidth form-inline">
                      {/*{task.cmd}*/}
                      {props.dealerSlugs && task.cmd.includes('#param') &&
                        <select className="form-control input-sm" defaultValue="" ref={(ref) => (self[`taskParam${taskId}`] = ref)}>
                          <option disabled value="">Velg forhandler</option>
                          {props.dealerSlugs.map((ds) => <option
                            key={ds.fields.slug['nb-NO']}
                            value={ds.fields.slug['nb-NO']}
                            data-makes={ds.fields.makes['nb-NO'].map((m) => m.fields.slug['nb-NO']).join(',')}
                          >{ds.fields.name['nb-NO']}</option>)}
                        </select>
                      }
                      &nbsp;
                      {(task.cmd.split('#param').length - 1) > 1 &&
                        <select className="form-control input-sm" defaultValue="" ref={(ref) => (self[`taskParam2${taskId}`] = ref)}>
                          <option value="">Alle merker</option>
                          <option value="Hongqi">Hongqi</option>
                          <option value="Mitsubishi">Mitsubishi</option>
                          <option value="renault">Renault</option>
                          <option value="dacia">Dacia</option>
                          <option value="voyah">Voyah</option>
                          <option value="dongfeng">Dongfeng</option>
                          <option value="changan">Changan</option>
                        </select>
                      }
                    </td>
                    <td>
                      <button className="btn btn-success" onClick={() => {
                        const param = self[`taskParam${taskId}`];
                        const param2 = self[`taskParam2${taskId}`];

                        let params;
                        if (param) {
                          params = [param.value];
                        }
                        if (param2) {
                          params.push(param2.value);
                        }

                        props.onRunTask(taskId, params);
                      }}>Kjør</button>
                    </td>
                  </tr>;
                })}
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <h2>Handlingskø</h2>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Handlings-ID</th>
              <th>Status</th>
              <th>Lagt i kø</th>
              <th>Køtid</th>
              <th>Kjøretid</th>
              <th>Respons</th>
            </tr>
          </thead>
          <tbody>
            {props.queue.reverse().map((queued) => {
              const formatter = new Intl.NumberFormat('nb-NO');
              let queuedAt = '-';
              let queuedAtFull = '';
              let queueTime = '-';
              let runTime = '-';

              if (queued.queuedAt) {
                queuedAt = queued.queuedAt.fromNow();
                queuedAtFull = queued.queuedAt.format('LLL');
              }

              if (queued.queuedAt && queued.startedAt) {
                const duration = moment.duration(queued.startedAt.diff(queued.queuedAt));
                queueTime = `${formatter.format(duration.asSeconds())} sekunder`;
              }

              if (queued.startedAt && queued.finishedAt) {
                const duration = moment.duration(queued.finishedAt.diff(queued.startedAt));
                runTime = `${formatter.format(duration.asSeconds())} sekunder`;
              }

              return (
                <tr key={queued.id}>
                  <td>{queued.id}</td>
                  <td title={queued.taskId}>
                    {(props.tasks[queued.taskId] && props.tasks[queued.taskId].name) || queued.taskId}
                    {queued.params &&
                      <span> ({queued.params.join(', ')})</span>
                    }
                  </td>
                  <td><TaskStatus status={queued.status} /></td>
                  <td title={queuedAtFull}>{queuedAt}</td>
                  <td>{queueTime}</td>
                  <td>{runTime}</td>
                  <td>
                    {queued.output && queued.output.stdout &&
                      <div>
                        <label>stdout</label>
                        <pre className="text-success mf-pre-limit-height">{queued.output.stdout}</pre>
                      </div>
                    }
                    {queued.output && queued.output.stderr &&
                      <div>
                        <label>stderr</label>
                        <pre className="text-danger mf-pre-limit-height">{queued.output && queued.output.stderr}</pre>
                      </div>
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="text-center">
        {printPager()}
      </div>
    </section>
  );
};
